// @ts-nocheck
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { createContext, useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import AboutUs from "./component/AboutUs";
import { AITerms } from "./component/AITerms";
import AppDeepLink from "./component/AppDeepLink";
import ChangePassword from "./component/client/ChangePassword";
import ClientAuthProvider from "./component/client/ClientAuthProvider";
import ClientPage from "./component/client/ClientPage";
import ForgotPassword from "./component/client/ForgotPassword";
import ResetPassword from "./component/client/ResetPassword";
import SignIn from "./component/client/SignIn";
import SignUp from "./component/client/SignUp";
import Gallery from "./component/Gallery";
import HamugaDeepLink from "./component/HamugaDeepLink";
import Layout from "./component/Layout";
import Lms from "./component/Lms";
import { Main } from "./component/Main";
import NotFound from "./component/NotFound";
import Payment from "./component/payment/Payment";
import Post from "./component/post/Post";
import PostList from "./component/post/PostList";
import PricingTable from "./component/PricingTable/PricingTable";
import Privacy from "./component/Privacy";
import PromoCodePublic from "./component/promo/PromoCodePublic";
import Schools from "./component/schools/Schools";
import ScrollToTop from "./component/ScrollToTop";
import Solution from "./component/Solution";
import Sponsors from "./component/sponsors/Sponsors";
import Team from "./component/Team";
import Tests from "./component/tests/Tests";
import TestTake from "./component/tests/TestTake";
import Terms from "./component/Terms";
import TomkoPlusTerms from "./component/TomkoPlusTerms";
import ClientAuthContext from "./context/ClientAuthContext";
import data from "./data/data.json";


export const ThemeContext = createContext(null);

const languageDataKeys = {
  mn: "Mongolian",
  en: "English",
  ko: "Korean",
  jp: "Japanese",
  de: "German",
  se: "Swedish",
  ru: "Russian",
  zh: "Chinese",
  tr: "Turkish",
  ar: "Arabic",
  fr: "French",
  es: "Spanish",
  kz: "Kazakh",
  uz: "Uzbek",
  az: "Azerbaijani",
  tj: "Tajik",
  kg: "Kyrgyz",
  tm: "Turkmen",
};

const deepMerge = (base, override) => {
  if (override === undefined) {
    return base;
  }

  if (!base || typeof base !== "object" || Array.isArray(base)) {
    return override;
  }

  if (!override || typeof override !== "object" || Array.isArray(override)) {
    return override;
  }

  return Object.keys(base).reduce(
    (merged, key) => ({
      ...merged,
      [key]: deepMerge(base[key], override[key]),
    }),
    { ...override }
  );
};

function App() {
  window.$ = window.jQuery = require("jquery");
  const [language, setLanguage] = useState("mn");
  const [userData, setUserData] = useState({});

  const getLanguageData = (lang) => {
    const languageKey = languageDataKeys[lang] || languageDataKeys.mn;
    const languageData = data[languageKey] || {};

    return languageKey === "English"
      ? data.English
      : deepMerge(data.English, languageData);
  };

  const isValidLanguage = (lang) => {
    return Object.keys(languageDataKeys).includes(lang);
  };

  useEffect(() => {
    // Check URL query parameter first
    const searchParams = new URLSearchParams(window.location.search);
    const langFromUrl = searchParams.get("lang");
    
    if (langFromUrl && isValidLanguage(langFromUrl)) {
      setLanguage(langFromUrl);
      localStorage.setItem("lingo_portal_app_lang", langFromUrl);
      return;
    }

    // If no valid lang in URL, check localStorage
    let app_lang = localStorage.getItem("lingo_portal_app_lang");
    if (app_lang) {
      if (isValidLanguage(app_lang)) {
        setLanguage(app_lang);
      } else {
        setLanguage("en");
      }
    } else {
      // If no lang in localStorage, fetch country code
      fetchCountryCode();
    }
  }, []);

  const fetchCountryCode = async () => {
    try {
      const response = await fetch("https://ipapi.co/json/");
      const data = await response.json();
      if (data.country_code === "MN") {
        setLanguage("mn");
        localStorage.setItem("lingo_portal_app_lang", "mn");
      } else if (data.country_code === "KR") {
        setLanguage("ko");
        localStorage.setItem("lingo_portal_app_lang", "ko");
      } else if (data.country_code === "JP") {
        setLanguage("jp");
        localStorage.setItem("lingo_portal_app_lang", "jp");
      } else if (data.country_code === "DE") {
        setLanguage("de");
        localStorage.setItem("lingo_portal_app_lang", "de");
      } else if (data.country_code === "SE") {
        setLanguage("se");
        localStorage.setItem("lingo_portal_app_lang", "se");
      } else if (data.country_code === "RU") {
        setLanguage("ru");
        localStorage.setItem("lingo_portal_app_lang", "ru");
      } else if (data.country_code === "CN") {
        setLanguage("zh");
        localStorage.setItem("lingo_portal_app_lang", "zh");
      } else if (data.country_code === "TR") {
        setLanguage("tr");
        localStorage.setItem("lingo_portal_app_lang", "tr");
      } else if (["AE", "SA", "EG", "QA", "KW", "BH", "OM"].includes(data.country_code)) {
        setLanguage("ar");
        localStorage.setItem("lingo_portal_app_lang", "ar");
      } else if (data.country_code === "FR") {
        setLanguage("fr");
        localStorage.setItem("lingo_portal_app_lang", "fr");
      } else if (data.country_code === "ES") {
        setLanguage("es");
        localStorage.setItem("lingo_portal_app_lang", "es");
      } else if (data.country_code === "KZ") {
        setLanguage("kz");
        localStorage.setItem("lingo_portal_app_lang", "kz");
      } else if (data.country_code === "UZ") {
        setLanguage("uz");
        localStorage.setItem("lingo_portal_app_lang", "uz");
      } else if (data.country_code === "AZ") {
        setLanguage("az");
        localStorage.setItem("lingo_portal_app_lang", "az");
      } else if (data.country_code === "TJ") {
        setLanguage("tj");
        localStorage.setItem("lingo_portal_app_lang", "tj");
      } else if (data.country_code === "KG") {
        setLanguage("kg");
        localStorage.setItem("lingo_portal_app_lang", "kg");
      } else if (data.country_code === "TM") {
        setLanguage("tm");
        localStorage.setItem("lingo_portal_app_lang", "tm");
      } else {
        setLanguage("en");
        localStorage.setItem("lingo_portal_app_lang", "en");
      }
    } catch (error) {
      console.error("Error fetching the country code:", error);
    }
  };

  return (
    <ThemeContext.Provider value={{ language, setLanguage }}>
      <ClientAuthContext.Provider value={{userData, setUserData}}>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path='/' element={<Layout data={data} language={language} />}>
            <Route path='/' element={<ClientAuthProvider />}>
              <Route index path='/' element={<Main data={data} language={language} />}/>
              <Route path='/school/client' element={<ClientPage data={{...getLanguageData(language).Client, ...getLanguageData(language).SignUp, ...getLanguageData(language).SignIn, ...getLanguageData(language).Error}}/>}/>
              <Route path="/school/signin" element={<SignIn data={{...getLanguageData(language).SignIn, ...getLanguageData(language).Error}}/>}/>
              <Route path="/change-password" element={<ChangePassword data={{...getLanguageData(language).SignUp, ...getLanguageData(language).Error}}/> }/>
              <Route path='/sponsor/payment/:id' element={
                <Payment data={{...getLanguageData(language).Payment, ...getLanguageData(language).Error}} priceData={getLanguageData(language).Price}/>}
              />
              <Route path="/signup" element={
                <SignUp data={{ ...getLanguageData(language).SignUp, ...getLanguageData(language).Error }} language={language}/>}
              />
              <Route path="/forgot-password" element={
                <ForgotPassword data={{...getLanguageData(language).SignIn, ...getLanguageData(language).Error}}/> }
              />
              <Route path="/school-reset-password" element={
                <ResetPassword data={{...getLanguageData(language).SignUp, ...getLanguageData(language).Error}}/> }
              />
              <Route path='/membership' element={
                <PricingTable data={getLanguageData(language).Price} />}
              />
              <Route path='/promocode/:code' element={
                <PromoCodePublic data={{...getLanguageData(language).PromoCode, ...getLanguageData(language).Error}} />}
              />
              <Route path='schools' element={
                <Schools data={getLanguageData(language).Schools} language={language} />}
              />
              <Route path='sponsors' element={
                <Sponsors data={getLanguageData(language).Sponsors} language={language} />}
              />
              <Route path='/about' element={<AboutUs data={getLanguageData(language).Members} />}/>
              <Route path='/team' element={<Team data={getLanguageData(language).Members} />}/>
              <Route path='/solution' element={<Solution data={getLanguageData(language).Solution} />}/>
              <Route path='/lms' element={<Lms data={getLanguageData(language).Lms} />}/>
              <Route path='gallery' element={<Gallery data={getLanguageData(language).Gallery} />}/>
              <Route path='posts' element={<PostList data={getLanguageData(language).Posts} />}/>
              <Route path='posts/:id' element={<Post data={getLanguageData(language).Posts}/>}/>
              <Route path='/tests' element={<Tests data={getLanguageData(language).Tests} />}/>
              <Route path='/tests/:id' element={<TestTake data={getLanguageData(language).Tests} language={language} />}/>
              <Route path='/ai-terms' element={<AITerms language={language} />} />
              <Route path='/terms' element={<Terms language={language} />} />
              <Route path='/privacy' element={<Privacy language={language} />} />
              <Route path='/tomko-plus-terms' element={<TomkoPlusTerms/>} />
              <Route path='/app' element={<AppDeepLink data={getLanguageData(language).AppDeepLink} deepLinkBase="tomko://app" />} />
              <Route path='/start' element={<AppDeepLink data={getLanguageData(language).AppDeepLink} deepLinkBase="tomko://start" />} />
              <Route path='/hamuga' element={<HamugaDeepLink data={getLanguageData(language).HamugaDeepLink} />} />
              <Route path='*' element={<NotFound data={getLanguageData(language).NotFound} language={language} />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
      </ClientAuthContext.Provider>
    </ThemeContext.Provider>
  );
}
export default App;
